import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Tooltip } from './ui/Tooltip';
import {
  SERVICE_FAILURE_TYPES,
  SERVICE_FAILURE_TYPE_DESCRIPTIONS,
} from '../constants/serviceFailureTypes';

/**
 * Info icon that lists what each service failure type means. Sits beside the
 * "Service Failure Type" label wherever the type is picked, so the definitions
 * are one hover away without opening the dropdown (which also shows them under
 * each option).
 */
export const ServiceFailureTypeHelp: React.FC<{ className?: string }> = ({ className = '' }) => (
  <Tooltip
    placement="top"
    content={
      <div className="max-w-xs space-y-2 text-xs text-left">
        {SERVICE_FAILURE_TYPES.map((t) => (
          <div key={t}>
            <div className="font-semibold">{t}</div>
            <div className="opacity-90">{SERVICE_FAILURE_TYPE_DESCRIPTIONS[t]}</div>
          </div>
        ))}
      </div>
    }
  >
    <button
      type="button"
      aria-label="What the service failure types mean"
      className={`inline-flex items-center text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 ${className}`}
    >
      <InformationCircleIcon className="h-3.5 w-3.5" />
    </button>
  </Tooltip>
);

export default ServiceFailureTypeHelp;
